export const IconName = {
  error: 'error',
  info: 'infoAlert',
  success: 'success',
};

export const Status = {
  success: 'succeeded',
};

export enum PAYMENT_STATUS {
  PAY_LATER = 'pay-later',
  QR_STAND = 'qr-stand',
  DYNAMIC_QR = 'dynamic-qr',
  PAY_NOW = 'payment',
  QR_ORACLE = 'qr-oracle',
}

export enum LOYALTY_TYPES {
  ONGOING = 0,
  PROMOTION = 1,
}

export enum SPLITBILL_TYPES {
  BYITEM = 'byItem',
  EQUALITY = 'equality',
}
